import styled from 'styled-components';
import { black } from 'constants/colors';
import { TABLET_WIDTH } from 'constants/breakPoints';
import InputBase from '@material-ui/core/InputBase';

export const AddUsersWrapper = styled.div`
  padding: 20px 0;
  margin: 0 auto;
  text-align: center;

  .face_bubble_text {
    color: ${black};
  }

  .faces_wrapper {
    text-align: center;
    display: block;
  }

  .selected_users_wrapper {
    width: calc(100% - 18rem);
    margin: 0 auto;
    text-align: left;

    @media (max-width: ${TABLET_WIDTH}px) {
      width: 100%;
    }
  }
`;

export const Searcher = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  background-color: #fff;
  border-radius: 20px;
  padding: 0px 10px;
  margin-bottom: 20px;
  height: 40px;
  border: 0.1rem solid #e9e9e9;

  img {
    width: 16px;
  }
`;

export const SearcherInput = styled(InputBase)`
  && {
    flex: 1;

    input {
      color: #4d4d4d;
      font-family: 'helvetica neue light';
      font-size: 14px;
      height: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/AddUsers/components/styles.js